import axios from "axios";
// import XXTEA from './xxtea'
import CryptoJS from "crypto-js";
import NProgress from "nprogress";
import { Message } from "element-ui";

import {
  apiBaseUrl,
  photoUpApi,
  SIGN_KEY,
  ENCRYPT_KEY,
} from "@/util/env.js";

function toQueryString(obj) {
  return obj
    ? Object.keys(obj)
        .sort()
        .map(function (key) {
          var val = obj[key];
          if (Array.isArray(val) && val.length) {
            return val
              .sort()
              .map(function (val2) {
                return key + "=" + encodeURIComponent(val2);
              })
              .join("&");
          }
          return key + "=" + encodeURIComponent(val);
        })
        .join("&")
    : "";
}

function getErrorInfo(errorCode, errorMsg) {
  let error = new Object();
  error.errorCode = errorCode;
  error.errorMsg = errorMsg;
  return error;
}

// 请求加密
axios.interceptors.request.use(
  (config) => {
    let isAPIRequest = config.url.indexOf(env.API_HOST) == 0 ? true : false;
    if (isAPIRequest) {
      var params = config.data || {};
      if (params != undefined) {
        for (let key in params) {
          if (params[key] === null || params[key] === undefined) {
            delete params[key];
          }
        }

        let post_body = params;

        let xSign = getSign(params);

        //config.headers['X-JPN-Lang'] = 'zh';
        config.headers["X-JPN-Language"] = localStorage.getItem("lastname");
        config.headers["X-JPN-Shop"] = localStorage.getItem("shopid");
        config.headers["X-JPN-Authorization"] = localStorage.getItem("token");

        let encry_post_body = "";
        let body = null;
        config.data = {};
        config.data = post_body;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应解密
axios.interceptors.response.use(
  (response) => {
    // 结束进度条
    NProgress.done();
    if (response) {
      // let isAPIRequest = response.config.url.indexOf(env.API_HOST) == 0 ? true : false;
      let isAPIRequest = true;

      if (isAPIRequest) {
        if (response.data) {
          // console.log('====================================');
          // console.log(response.data);
          // console.log('====================================');
          if (
            (response.data.code === 10001 || response.data.code === 10002) &&
            window.jump
          ) {
            return;
          }
          if (response.data.code === 10001 || response.data.code === 10002) {
            Message.error(response.data.message);
            window.jump = true;
            setTimeout(function () {
              window.location.href = "/merchant_admin";
            }, 1500);
            return;
          }
          return response.data;
          if (response.data.success && response.data.code === 200) {
            return response.data;
          } else if (response.data.code === 404) {
            let errorMessage = response.data.message;
            let errorCode = response.data.code;
            let message = response.data.message ? response.data.message : "";
            // if (response.data.message) {
            //     message =
            //     console.log('网络错误, 错误代码:=' + errorCode + "错误信息:=" + errorMessage);
            //     return Promise.reject({ 'errorCode': errorCode, 'errorMsg': errorMessage });
            // }
            if (window.history.length <= 1) {
              window.location.hash = "/dashboard";
            } else {
              window.history.go(-1);
            }
            return Promise.reject({
              errorCode: errorCode,
              errorMsg: errorMessage,
            });
          } else {
            let errorMessage = response.data.message;
            let errorCode = response.data.code;
            let message = response.data.message ? response.data.message : "";

            return Promise.reject({
              errorCode: errorCode,
              errorMsg: errorMessage,
            });
          }
        }
      } else {
        console.log("请求地址错误!");
      }
    } else {
      console.log("网络错误");
    }
  },
  (error) => {
    NProgress.done();
    return Promise.reject(error.response.data);
  }
);

// 发起请求
export function fetchEndpoint(reqUrl, type = "POST", data = {}) {
  if (!reqUrl) {
    return;
  }
  type = type.toUpperCase();
  reqUrl = env.API_HOST + reqUrl;
  if (type == "GET") {
    let dataStr = ""; //数据拼接字符串
    Object.keys(data).forEach((key) => {
      dataStr += key + "=" + data[key] + "&";
    });

    if (dataStr !== "") {
      dataStr = dataStr.substr(0, dataStr.lastIndexOf("&"));
      reqUrl = reqUrl + "?" + dataStr;
    }
  }
  // 开始进度条
  if (reqUrl.indexOf("/excel/down/list") >= 0) {
  } else {
    NProgress.start();
  }
  return new Promise((resolve, reject) => {
    axios({
      method: type,
      url: reqUrl,
      data: data,
    }).then(
      (res) => {
        resolve(res);
      },
      (error) => {
        let errMsg = "ネットワークエラー";
        let lang = localStorage.getItem("lastname");
        if (lang === "zh") {
          errMsg = "网络错误";
        }
        let obj = { success: false };
        if (typeof error == "object" && error.message) {
          errMsg = error.message;
          obj = error;
        } else {
          obj.message = errMsg;
        }
        Message.error(errMsg);
        resolve(obj);
      }
    );
  });
}

export function getSign(params) {
  // console.log(params);

  let post_body = toQueryString(params);
  // let post_body = params;

  // timestamp: 客户端秒级时间戳
  let timestamp = Date.parse(new Date()) / 1000 + "";

  // sign: HMAC-SHA256( timestamp + post_body, SIGN_KEY )
  let sign = CryptoJS.HmacSHA256(timestamp + post_body, SIGN_KEY);

  // xSign格式: sign,timestamp
  let xSign = sign + "," + timestamp;
  return xSign;
}
